import React from 'react';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AgentSelection from '../../components/AgentSelection/AgentSelection';
import Button from '../../components/Button/Button';
import Modal from '../../components/Modal/Modal';
import TeamBox from '../../components/TeamBox/TeamBox';
import { ReactComponent as CloseIcon } from '../../images/Close.svg';
import { ReactComponent as TeamLogo } from '../../images/teamLogo.svg';
import { randomColorAndLighter } from '../../utils/functions';
import { AiOutlineCheck } from 'react-icons/ai';
import './marketerteams.scss';
import Input from '../../components/Input/Input';
import NotificationModal from '../../components/NotificationModal/NotificationModal';
import { useRef } from 'react';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import Spinner from '../../components/Spinner/Spinner';
import base from '../../apis';
import { toast } from 'react-toastify';
import { enterMarketingExec } from '../../actions';

function MarketerTeams() {
  const dispatch = useDispatch();
  const [isTeam, setIsTeam] = useState(true);
  const [teamsModalOpen, setTeamsModalOpen] = useState(false);
  const [selectedAgents, setSelectedAgents] = useState([]);
  const [teamToAssignTo, setteamToAssignTo] = useState(null);
  // const { data: mk_data, error: mk_error, isLoading: mkIsLoading } = useFetch('/operations/marketing_teams/');
  // const { data: exec_data, error: exec_error, isLoading: execIsLoading } = useFetch('/operations/marketers/');
  // const exec_data = useSelector((state) => state.marketingExec.marketingExecutives)
  const [mk_execs, setMk_execs] = useState({
    data: [],
    isLoading: false,
  });
  const [teams, setTeams] = useState({
    data: [],
    isLoading: false,
  });
  const [teamsToAssignTo, setTeamsToAssignTo] = useState([]);
  const EXECUTIVES = useRef([]);
  const TEAMS = useRef([]);
  const [searchParam, setSearchParam] = useState('');

  useEffect(() => {
    const controller = new AbortController();
    setMk_execs((value) => ({ ...value, isLoading: true }));
    base
      .get('/operations/marketers/', { signal: controller.signal })
      .then(({ data }) => {
        setMk_execs((value) => ({ ...value, data, isLoading: false }));
        dispatch(enterMarketingExec(data));
        EXECUTIVES.current = data;
        if (data?.length === 0) {
          toast.warn('No marketing executives Found');
        }
      })
      .catch((err) => {
        setMk_execs((value) => ({ ...value, isLoading: false }));
        toast.error('Error Loading Marketing Executives');
      });
  }, [dispatch]);
  useEffect(() => {
    const controller = new AbortController();
    setTeams((value) => ({ ...value, isLoading: true }));
    base
      .get('/operations/marketing_teams/', { signal: controller.signal })
      .then(({ data }) => {
        setTeams((value) => ({ ...value, data, isLoading: false }));
        TEAMS.current = data;
        if (data?.length === 0) {
          toast.warn('No teams found');
        }
      })
      .catch((err) => {
        setTeams((value) => ({ ...value, isLoading: false }));
        toast.error('Error Loading Marketing Executives');
      });
  }, []);

  useEffect(() => {
    setSearchParam('');
    if (isTeam) {
      setTeams((value) => ({ ...value, data: TEAMS.current }));
    } else {
      setMk_execs((value) => ({ ...value, data: EXECUTIVES.current }));
    }
  }, [isTeam]);

  const toggleAgentSelection = (id) => {
    if (selectedAgents.includes(id)) {
      setSelectedAgents(selectedAgents.filter((agent) => agent !== id));
    } else {
      setSelectedAgents([...selectedAgents, id]);
    }
  };

  const onAssignToTeam = () => {
    if (selectedAgents.length > 0) {
      setTeamsToAssignTo(TEAMS.current);
      setTeamsModalOpen(true);
    } else {
      toast.warn('Please select at least one agent');
    }
  };

  const onSearch = (e) => {
    e.preventDefault();
    if (searchParam === '') {
      setTeams((value) => ({ ...value, data: TEAMS.current }));
      setMk_execs((value) => ({ ...value, data: EXECUTIVES.current }));
    } else {
      if (isTeam) {
        const filteredTeams = TEAMS.current.filter((team) =>
          team.name.toLowerCase().includes(searchParam.toLowerCase())
        );
        setTeams((val) => ({ ...val, data: filteredTeams }));
      } else {
        const filteredExecs = EXECUTIVES.current.filter((exec) => {
          const name = exec.user.first_name + ' ' + exec.user.last_name;
          return name.toLowerCase().includes(searchParam.toLowerCase());
        });

        setMk_execs((val) => ({ ...val, data: filteredExecs }));
      }
    }
  };

  const onAssignTeamSearch = (e) => {
    const value = e.target.value;
    if (value === '') {
      setTeamsToAssignTo(TEAMS.current);
    } else {
      const filteredTeams = TEAMS.current.filter((team) => team.name.toLowerCase().includes(value.toLowerCase()));
      setTeamsToAssignTo(filteredTeams);
    }
  };
  const [isLoading, setIsLoading] = useState(false);
  const onAddMembersToTeam = () => {
    if (!teamToAssignTo) {
      toast.warn('Please select a team');
    } else {
    }
    setIsLoading(true);
    base
      .put(`/operations/marketing_teams/${teamToAssignTo}/`, {
        members: selectedAgents.map((id) => ({ id })),
      })
      .then((res) => {
        toast.success('Members added to team');
        setTeamsModalOpen(false);
        setSelectedAgents([]);
        setteamToAssignTo(null);
      })
      .catch((err) => {
        toast.error('Error adding members to team');
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  //set teamtoassignto to null, set assignable teams to all teams, and close modal
  const onCloseReset = () => {
    setTeamsModalOpen(false);
    setteamToAssignTo(null);
    setTeamsToAssignTo(TEAMS.current);
  };

  const navigate = useNavigate();
  return (
    <>
      {isLoading && <Spinner />}
      <NotificationModal isOpen={false} message="Assigned successfully to the team" />
      <Modal open={teamsModalOpen} onClose={onCloseReset}>
        <div className="teamsmodal">
          <div className="teamsmodal__header">
            <h1>Assign Members To A Team</h1>
            <Button
              style={{
                width: '100px',
                fontSize: '18px',
                padding: '10px',
                color: 'white',
                backgroundColor: 'var(--primary-color)',
                display: 'block',
              }}
              onClick={onAddMembersToTeam}
              text="Save"
            />

            <CloseIcon className="closer" onClick={onCloseReset} />
          </div>
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              width: '78%',
              margin: '10px auto',
            }}>
            <h2>Teams</h2>
            <Input placeholder="Enter team name" type="search" onChange={onAssignTeamSearch} />
          </div>
          <div className="teamsmodal__content">
            {teamsToAssignTo?.map(({ id, ...team }) => (
              <TeamBoxHorizontal
                key={id}
                onToggle={() => setteamToAssignTo(id)}
                {...team}
                selected={teamToAssignTo === id}
              />
            ))}
          </div>
        </div>
      </Modal>
      <div className="marketerteams">
        <div className="marketerteams__head">
          <form onSubmit={onSearch}>
            <Input
              placeholder={isTeam ? "By Teams's name" : "By Executive's name"}
              value={searchParam}
              onChange={(e) => setSearchParam(e.target.value)}
              type="search"
            />
            <Button
              style={{
                width: 'fit-content',
                padding: '10px 30px',
                color: 'white',
                fontSize: '16px',
                backgroundColor: 'var(--primary-color)',
              }}
              type="submit"
              text="Filter"
            />
          </form>
          <div>
            <p data-selected={isTeam ? true : false} onClick={() => setIsTeam(true)}>
              Teams
            </p>
            {/* <p
              data-selected={!isTeam ? true : false}
              onClick={() => setIsTeam(false)}
            >
              Marketing Executive
            </p> */}
          </div>
        </div>
        <div className="marketerteams__body">
          {isTeam ? (
            teams.isLoading ? (
              <Spinner overlay={false} />
            ) : (
              <>
                <h1>Teams</h1>
                <div className="marketerteams__teams">
                  {teams.data?.map(({ id, members_count, name }) => (
                    <TeamBox
                      onClick={(color) =>
                        navigate(`${id}`, {
                          state: { color, name, members_count },
                        })
                      }
                      key={id}
                      numOfMembers={members_count}
                      teamName={name}
                    />
                  ))}
                </div>
              </>
            )
          ) : mk_execs.isLoading === 0 ? (
            <Spinner overlay={false} />
          ) : (
            <>
              <h1>Marketing Executives</h1>
              <div className="marketerteams__executive">
                {mk_execs?.data?.map(({ id, user: { first_name, last_name } }) => (
                  <AgentSelection
                    name={first_name + ' ' + last_name}
                    selected={selectedAgents.includes(id)}
                    onToggle={() => toggleAgentSelection(id)}
                    key={id}
                  />
                ))}
              </div>
              <Button
                style={{
                  width: 'fit-content',
                  fontSize: '18px',
                  padding: '10px 30px',
                  color: 'white',
                  backgroundColor: 'var(--primary-color)',
                  display: 'block',
                  marginLeft: 'auto',
                }}
                onClick={onAssignToTeam}
                text="Assign to a team"
              />
            </>
          )}
        </div>
      </div>
    </>
  );
}

export default MarketerTeams;

const TeamBoxHorizontal = ({ selected, onToggle, name, members_count }) => {
  const { color, lighter } = randomColorAndLighter();
  const colors = useRef({ color, lighter });
  return (
    <div className="teamboxhorizontal" style={{ backgroundColor: colors.current.lighter }}>
      <TeamLogo color={colors.current.color} style={{ width: '50px', height: '50px ' }} />
      <div className="teamboxhorizontal__names">
        <h5>{name}</h5>
        <span>{members_count}</span>
      </div>
      <div className="agentselection__checker" onClick={onToggle} style={{ marginLeft: 'auto' }}>
        {selected && <AiOutlineCheck color="var(--primary-color)" />}
      </div>
    </div>
  );
};
